var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',_vm._g(_vm._b({staticClass:"base-input-number",class:{ 'is-error': _vm.isError },style:({ width: _vm.width }),attrs:{"size":_vm.size}},'el-input-number',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }